import React from 'react'
import '../../App.css'

import AboutMeintro from '../AboutPage';
import Footer from '../Footer';
function AboutMe(){
    return(
        <>
        <AboutMeintro/>
        <Footer />
        </>
    )
}
export default AboutMe;